import React, { useState, useEffect } from 'react';
import "./carousel.css"
import CarouselList from './CarouselList'

export default function CarouselListCont( { gallery, bar, autoChange } ) {

    const [fullscreen, setFullscreen] = useState(false)
    const toFullScren = () => {
        setFullscreen(!fullscreen)
    }

  return (
    <div className={`carousel-list-cont ${fullscreen ? 'carousel-fullscreen' : ''} `}>
        <CarouselList gallery={gallery} bar={bar} toFullScren={toFullScren} fullscreen={fullscreen} autoChange={autoChange} />
    </div>
  )
}
